// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a393c84e","308":"ddf6860a","425":"f0627bf7","445":"21c0e73c","498":"ec41ca86","799":"259e888d","838":"94231cfe","859":"0c4c26ca"}[chunkId] + ".chunk.js";
};